export default __webpack_public_path__ + "static/media/Wrathward Helm.97a917e3.jpg";